import { Form, Input, Select } from 'antd'
import React from 'react'
import {
  CATCH_BOARD_READINESSES,
  CATCH_BOARD_READINESS_NOTE_MAX_LENGTH,
  getCatchBoardReadinessLabel,
  readinessRequiresNote,
} from './catchBoardConstants'
import styled from 'styled-components/macro'

const { TextArea } = Input
const { Option } = Select

/**
 * Exclusive “who acts next” picker. Snag note is modal-only and required
 * when CS or product is the blocker.
 */
const CatchBoardDealReadinessSection = ({
  form,
  onFieldChange,
  disabled = false,
}) => {
  const needsNote = readinessRequiresNote(form?.readiness)

  return (
    <Section data-testid='catch-board-deal-readiness-fields'>
      <Form.Item label='Readiness' style={{ marginBottom: 12 }}>
        <Select
          style={{ width: '100%' }}
          dropdownMatchSelectWidth={false}
          dropdownStyle={{ minWidth: 240 }}
          value={form?.readiness || ''}
          disabled={disabled}
          onChange={value => onFieldChange('readiness', value || null)}
          data-testid='catch-board-deal-readiness'
        >
          <Option value=''>Not triaged</Option>
          {CATCH_BOARD_READINESSES.map(readiness => (
            <Option key={readiness} value={readiness}>
              {getCatchBoardReadinessLabel(readiness)}
            </Option>
          ))}
        </Select>
      </Form.Item>

      <SectionHint>
        Who should act next. Unset stays quiet on the board.
      </SectionHint>

      {needsNote ? (
        <Form.Item label='Snag note' required style={{ marginBottom: 12 }}>
          <TextArea
            rows={3}
            value={form?.readinessNote || ''}
            maxLength={CATCH_BOARD_READINESS_NOTE_MAX_LENGTH}
            disabled={disabled}
            placeholder='Tell CS or product what they need to unblock this…'
            onChange={event =>
              onFieldChange('readinessNote', event.target.value)
            }
            data-testid='catch-board-deal-readiness-note'
          />
        </Form.Item>
      ) : null}
    </Section>
  )
}

const Section = styled.div`
  margin-bottom: 4px;
`

const SectionHint = styled.p`
  margin: -4px 0 12px;
  font-size: 12px;
  line-height: 1.4;
  color: ${({ theme }) => theme.colours.stormGrey || '#666'};
`

export default CatchBoardDealReadinessSection
